module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Db-Fc-Gb-Hc-Ia-outside.95c6d1d3.png";